import React, { useEffect } from "react";
import footerData from "../Json/FooterData.json";
import "../Style/FooterSection.css";
import { myCustomTheme } from "../Theme";
import { Link } from "react-router-dom";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import FooterLogo from "../Assets/3d.png";

const theme = myCustomTheme;

const images = {
  footerLogo: FooterLogo,
};

// SOCIAL ICONS MAP
const socialIcons = {
  FaFacebookF: <FaFacebookF />,
  FaTwitter: <FaXTwitter />,
  FaInstagram: <FaInstagram />,
  FaYoutube: <FaYoutube />,
};

const Footer = () => {

  // FOOTER OPEN ANIMATION
  useEffect(() => {

    const footer = document.querySelector(".crazy-footer");

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }

        });

      },
      { threshold: 0.15 }
    );

    if (footer) {
      observer.observe(footer);
    }

    return () => {

      if (footer) {
        observer.unobserve(footer);
      }

    };

  }, []);

  // ADD socials HERE
  const {
    brand,
    quickLinks,
    services,
    contact,
    socials
  } = footerData;

  return (
    <footer
      className="crazy-footer"
      style={{
        background: `
          radial-gradient(circle at top left, ${theme.colors.high_light}55, transparent 30%),
          radial-gradient(circle at bottom right, ${theme.colors.bg_secondary}66, transparent 30%),
          linear-gradient(
            135deg,
            ${theme.colors.bg_primary},
            ${theme.colors.header_footer_bg},
            ${theme.colors.bg_secondary}
          )
        `,
      }}
    >

      {/* LIGHT EFFECTS */}
      <div className="crazy-light light-one"></div>

      <div className="crazy-light light-two"></div>

      {/* MAIN BOX */}
      <div className="crazy-footer-wrapper">

        {/* ================= BRAND ================= */}
        <div
          className="crazy-card"
          style={{
            animationDelay: "0.2s"
          }}
        >

          <Link to="/" className="logo-box">

            <img
              src={images[brand.logoKey]}
              alt="logo"
              className="footer-logo"
            />

          </Link>

          <p
            className="footer-description"
            style={{
              color: theme.colors.menu_text,
              fontFamily: theme.typography.text_font,
            }}
          >
            {brand.description}
          </p>

          {/* SOCIALS */}
          <div className="social-wrapper">

            {socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                {socialIcons[social.icon]}
              </a>
            ))}

          </div>

        </div>

        {/* ================= QUICK LINKS ================= */}
        <div
          className="crazy-card"
          style={{
            animationDelay: "0.4s"
          }}
        >

          <h3
            className="footer-heading"
            style={{
              color: theme.colors.heading,
              fontFamily: theme.typography.heading_font,
            }}
          >
            Quick Links
          </h3>

          <nav className="footer-nav">

            {quickLinks.map((link, i) => (
              <Link
                key={i}
                to={link.path}
                className="footer-nav-link"
                style={{
                  color: theme.colors.menu_text,
                  fontFamily: theme.typography.text_font,
                }}
              >
                {link.name}
              </Link>
            ))}

          </nav>

        </div>

        {/* ================= SERVICES ================= */}
        <div
          className="crazy-card"
          style={{
            animationDelay: "0.6s"
          }}
        >

          <h3
            className="footer-heading"
            style={{
              color: theme.colors.heading,
              fontFamily: theme.typography.heading_font,
            }}
          >
            Services
          </h3>

          <ul className="footer-services-list">

            {services.map((service, i) => (
              <li
                key={i}
                className="service-item"
                style={{
                  color: theme.colors.menu_text,
                  fontFamily: theme.typography.text_font,
                }}
              >
                <span className="service-dot"></span>
                {service}
              </li>
            ))}

          </ul>

        </div>

        {/* ================= CONTACT ================= */}
        <div
          className="crazy-card"
          style={{
            animationDelay: "0.8s"
          }}
        >

          <h3
            className="footer-heading"
            style={{
              color: theme.colors.heading,
              fontFamily: theme.typography.heading_font,
            }}
          >
            Contact
          </h3>

          <div className="footer-contact-wrapper">

            {/* PHONE */}
            <div className="contact-item">

              <div className="contact-icon">
                <FaPhoneAlt />
              </div>

              <a
                href={`tel:${contact.phone}`}
                className="contact-link"
                style={{
                  color: theme.colors.heading,
                  fontFamily: theme.typography.text_font,
                  textDecoration: "none",
                }}
              >
                {contact.phone}
              </a>

            </div>

            {/* EMAIL */}
            <div className="contact-item">

              <div className="contact-icon">
                <FaEnvelope />
              </div>

              <a
                href={`mailto:${contact.email}`}
                className="contact-link"
                style={{
                  color: theme.colors.heading,
                  fontFamily: theme.typography.text_font,
                  textDecoration: "none",
                }}
              >
                {contact.email}
              </a>

            </div>

            {/* LOCATION */}
            <div className="contact-item">

              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>

              <a
                href="https://maps.google.com/?q=Hilton+Business+Center+Surat"
                target="_blank"
                rel="noreferrer"
                className="location-link"
                style={{
                  color: theme.colors.menu_text,
                  fontFamily: theme.typography.text_font,
                }}
              >
                {contact.location}
              </a>

            </div>

          </div>

        </div>

      </div>

      {/* COPYRIGHT */}
      {/* COPYRIGHT */}
      <div className="footer-copyright">

        <p
          style={{
            color: theme.colors.menu_text,
            fontFamily: theme.typography.text_font,
          }}
        >
          © 2026 {brand.name} Engineering Consultancy LLP
        </p>

        {/* DEVELOPER LINK
        <a
          href="https://www.instagram.com/_mr.patoliya_?igsh=MTFnNml4ZDg2cTly"
          target="_blank"
          rel="noopener noreferrer"
          className="developer-link"
        >
          Developed by Mithil Patoliya
        </a> */}


      </div>

    </footer>
  );
};

export default Footer;